module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/related/zh-hans_5-4e197f994c37bfa659b67301afefaaf1.jpg";